import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionContractsService } from '../services/constructionContracts.service';
import type { ConstructionContract } from '../types/construction-contracts.types';
import { toast } from 'sonner';

export function useConstructionContractDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-contracts', 'detail', id],
    queryFn: () => ConstructionContractsService.getContractDetail(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionContract>) => ConstructionContractsService.updateContract(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-contracts'] });
      queryClient.invalidateQueries({ queryKey: ['construction-contracts', 'detail', id] });
      toast.success('Cập nhật hợp đồng thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật hợp đồng: ' + error.message);
    }
  });

  return {
    contract: query.data,
    isLoading: query.isLoading,
    error: query.error,
    updateContract: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
